import { Chip } from '@mui/material'
import { FC } from 'react'

interface EditModeChipProps {
  label?: string
}

export const EditModeChip: FC<EditModeChipProps> = ({ label = 'Editando Capa' }) => {
  return (
    <Chip
      color="primary"
      label={label}
      sx={{
        position: 'absolute',
        top: '10px',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 1000,
        fontWeight: 'bold',
      }}
    />
  )
}
